module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Interactive', {
    on: {
      "signal:pointer_tuple": _vm.onPointer
    }
  }), _c('div', [_c('span', [_vm._v(_vm._s(_vm.field) + " : " + _vm._s(_vm.value))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f79b9334","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./_docs/partials/examples/SignalInteractivityExample.vue
// module id = 1650
// module chunks = 1